import type { TeamMember } from "../../Booking-Form/typings/team-member";

type TeamMemberPhotoSource = {
  userId: string;
  photoUrl?: string | null;
};

export function storedColleaguesExcludingUser(
  colleagues: TeamMember[],
  storedColleagueIds: readonly string[],
  currentUserId: string
): TeamMember[] {
  const storedIds = new Set(storedColleagueIds);

  return colleagues.filter(
    colleague => colleague.userId !== currentUserId && storedIds.has(colleague.userId)
  );
}

export function colleagueDisplayName(colleague: TeamMember): string {
  const first = colleague.firstName?.trim() ?? "";
  const last = colleague.surname?.trim() ?? "";

  if (first && last) {
    return `${first} ${last.charAt(0)}.`;
  }

  return first || last || colleague.userId;
}

export function enrichTeamMembersWithPhotoUrl(
  members: TeamMember[],
  photoSources: ReadonlyArray<TeamMemberPhotoSource> | undefined,
  currentUser?: { userId: string; photoUrl?: string | null }
): TeamMember[] {
  if (!photoSources?.length && currentUser?.photoUrl == null) {
    return members;
  }

  return members.map(member => {
    const fromSource = photoSources?.find(source => source.userId === member.userId)?.photoUrl;
    const fromCurrentUser =
      currentUser?.userId === member.userId ? currentUser.photoUrl : undefined;
    const photoUrl = member.photoUrl ?? fromSource ?? fromCurrentUser ?? null;

    if (photoUrl === member.photoUrl) {
      return member;
    }

    return { ...member, photoUrl };
  });
}
